import React, { useState, useEffect } from "react";
import SavingsDataService from "./services/SavingsService";

const Savings = props => {
  const initialSavingsState = {
    amount: "",
    previousBalance: "",
    newBalance: ""
  };
  const [currentSavings, setCurrentSavings] = useState(initialSavingsState);
  const [message, setMessage] = useState("");

  const getSavings = id => {
    SavingsDataService.get(id)
      .then((response) => {
        // response handled below — removed sensitive console output
        setCurrentSavings(response.data);
      })
      .catch(e => {
        console.log(e);
      });
  };

  useEffect(() => {
    getSavings(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = event => {
    const { name, value } = event.target;
    setCurrentSavings({ ...currentSavings, [name]: value });
  };

  const updateSavings = () => {
    SavingsDataService.update(currentSavings.id, currentSavings)
      .then((response) => {
        setMessage("Savings transactions was updated successfully!");
      })
      .catch(e => {
        console.log(e);
      });
  };

  const deleteSavings = () => {
    SavingsDataService.remove(currentSavings.id)
      .then((response) => {
        console.log(response.data);
        props.history.push("/savings");
      })
      .catch(e => {
        console.log(e);
      });
  };

  return (
    <div>
      {currentSavings ? (
        <div className="edit-form">
          <h4>Savings Transactions</h4>
          <form>
            <div className="form-group">
              <label htmlFor="amount">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                name="amount"
                value={currentSavings.amount}
                onChange={handleInputChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="previousBalance">Previous Balance</label>
              <input
                type="text"
                className="form-control"
                id="previousBalance"
                name="previousBalance"
                value={currentSavings.previousBalance}
                onChange={handleInputChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="newBalance">New Balance</label>
              <input
                type="text"
                className="form-control"
                id="newBalance"
                name="newBalance"
                value={currentSavings.newBalance}
                onChange={handleInputChange}
              />
            </div>
          </form>      

          <button className="badge badge-danger mr-2" onClick={deleteSavings}>
            Delete
          </button>

          <button
            type="submit"
            className="badge badge-success"
            onClick={updateSavings}
          >
            Update
          </button>
          <p>{message}</p>
        </div>
      ) : (
        <div>
          <br />
          <p>Please click on a Savings Transaction...</p>
        </div>
      )}
    </div>
  );
};

export default Savings;
